import React from 'react';
import './tooltipContent.scss';

function newlineText(text) {
  return text.split('\n').map((str) => <p>{str}</p>);
}

function TooltipContent({ title, data }) {
  const { lagging, basic, leading } = data;
  const preventClick = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };
  return (
    <div
      className="TooltipContainer"
      onClickCapture={preventClick}
      onMouseDownCapture={preventClick}
      onAuxClickCapture={preventClick}
    >
      <div className="TooltipTitle">{title}</div>
      <div className="TooltipColumn">
        <span>Lagging</span>
        <div>{newlineText(lagging)}</div>
      </div>
      <div className="TooltipColumn">
        <span>Basic</span>
        <div>{newlineText(basic)}</div>
      </div>
      <div className="TooltipColumn">
        <span>Leading</span>
        <div>{newlineText(leading)}</div>
      </div>
    </div>
  );
}

export default TooltipContent;
